import { globalActions } from './global';

export const acceptCookiePolicy = () => async dispatch => {
  dispatch(globalActions.acceptCookiePolicyComplete());
};

